import React, { useEffect } from 'react'
import { Typography } from '@material-ui/core'

import { ChatMessageContent, ShowProjectPlanResponse } from '../../../types'
import { Container } from '../../../../../../components/Container'
import { ProjectPlanController } from '../../../../../../hooks/useProjectPlan'

interface Props {
    message: ChatMessageContent
    projectPlanController: ProjectPlanController
}

export const ProjectPlanCard: React.FC<Props> = ({
    message,
    projectPlanController,
}) => {
    if (!message.function_call_response) return null
    const showProjectPlanResponse: ShowProjectPlanResponse = message.function_call_response as ShowProjectPlanResponse

    useEffect(() => {
        projectPlanController.getProjectPlanList()
    }, [])

    return (
        <Container
            style={{
                flexDirection: 'column',
            }}
        >
            <Container>
                <Typography variant="body1" color="textSecondary">
                    {showProjectPlanResponse.message}
                </Typography>
            </Container>
        </Container>
    )
}
